import React, {Component} from "react"
import { Panel, Button, Glyphicon, Col } from "react-bootstrap"
import { ViewCallHistoryElement, ViewVoiceTextElement, ViewCommentElement, ViewAudioControlElement, ViewCallCategoryTagElement} from "../Elements/AscElements/CallAnalysisElements";
import ButtonSpeechBubble from "../Elements/AscElements/SetButtonWithSpeechBubble";
import AscModal from "../Elements/Modal/Modal";
import "../Elements/FromGroup/form_select.css";
import InlineForm from "../Elements/FromGroup/InlineForm";

export default class CallAnalysisModal extends Component {
    getModalInfo = (modalType) => {
        let {
            langText,
            state,
            propSetState,
            validationHandle,
            onClick,
            customBtn1Func,
            customBtn2Func
        } = this.props;
        let info = null;

        switch (modalType) {
            case "analysis":
                info = (
                    <AscModal
                        state = {state}
                        propSetState = {propSetState}
                        langText = {langText}
                        validationHandle = {validationHandle}
                        onClick = {onClick}
                        customBtn1Func = {customBtn1Func}
                        customBtn2Func = {customBtn2Func}
                        customBtn1Msg = {(
                            state.selected
                            && state.selected.flag_data_json
                            && state.selected.flag_data_json.check_flag === "Y")
                            ? langText.Body.UnConfirmed
                            : langText.Body.Check
                        }
                        customBtn2Msg = {langText.Body.Close}
                        customBtn1Class = {(
                            state.selected
                            && state.selected.flag_data_json
                            && state.selected.flag_data_json.check_flag === "Y")
                            ? "unconfirmed-execute"
                            : "confirmed-execute"
                        }
                        customBtn2Class = "close-execute"
                        customBtn1Disabled = {validationHandle}
                    >
                        {this.getItemInfo(modalType)}
                    </AscModal>
                );
                break;
        
            case "voiceQualityAnalysisDownload":
                // 分析履歴ダウンロード
                info = (
                    <AscModal
                        state = {state}
                        propSetState = {propSetState}
                        langText = {langText}
                        validationHandle = {validationHandle}
                        onClick = {() => onClick}
                    >
                        {this.getItemInfo(modalType)}
                    </AscModal>
                );
                break;
            case "callContentDownload":
                // 通話内容ダウンロード
                info = (
                    <AscModal
                        state = {state}
                        propSetState = {propSetState}
                        langText = {langText}
                        validationHandle = {validationHandle}
                        onClick = {() => onClick}
                    >
                        {this.getItemInfo(modalType)}
                    </AscModal>
                );
                break;
            case "callMeasurementDownload":
                // 発話計測ダウンロード
                info = (
                    <AscModal
                        state = {state}
                        propSetState = {propSetState}
                        langText = {langText}
                        validationHandle = {validationHandle}
                        onClick = {() => onClick}
                    >
                        {this.getItemInfo(modalType)}
                    </AscModal>
                );
                break;
            default:
                break;
        }

        return info;
    }

    getItemInfo = (modalType) => {
        let {
            langText,
            state,
            boardWidth,
            propSetState,
            copyData,
            userInfo,
            updateVoiceData,
            screenName,
            getFilterData,
            getKeywordData,
            currentPermission,
            onPlayHandle,
            insertCommentData,
            updateCommentData,
            deleteCommentData,
            charaLimit,
            onTextChange_Limit,
            updateCallCategoryTag,
            onSelectChange,
            validationHandle,
            hasInvalidFileNameCharacters
        } = this.props;
        let info = null;

        switch (modalType) {
            case "analysis":
                info = (
                    <>
                        <Panel bsStyle="info">
                            <Panel.Heading>
                                <Panel.Title>
                                    {langText.Body.CallHistoryName}
                                </Panel.Title>
                            </Panel.Heading>
                            <ViewCallHistoryElement
                                state={state}
                                langText={langText}
                                boardWidth={boardWidth}
                            />
                        </Panel>
                        {
                            state.search_company_parameter_call_auto_tag &&
                            <Panel bsStyle="info">
                                <Panel.Heading>
                                    <Panel.Title>
                                        {langText.Body.CallCategoryTag}
                                    </Panel.Title>
                                </Panel.Heading>
                                <Panel.Body>
                                    <ViewCallCategoryTagElement
                                        state={state}
                                        langText={langText}
                                        userInfo={userInfo}
                                        propSetState={propSetState}
                                        updateCallCategoryTag={updateCallCategoryTag}
                                        currentPermission={currentPermission}
                                    />
                                </Panel.Body>
                            </Panel>
                        }
                        <Panel bsStyle="info">
                            <Panel.Heading>
                                <Panel.Title>
                                    {langText.Body.VoiceText}
                                    {state && state.selected && state.selected.text_data_json.length !==0 && 
                                    //音声テキストがあれば全体音声テキストコピーボタン・自動スクロールボタン表示
                                    <>
                                    <span className="pannel-btn-right">
                                        <ButtonSpeechBubble
                                            className="control-button"
                                            bsSize="xsmall"
                                            onClick={e => {
                                                let player = document.getElementById("audio-text-player");
                                                let panel = document.getElementById("voice-text-panel");

                                                // アクティブなメッセージボックスの色をリセット
                                                const ELEMENT_CLASS_NAMES = ["current-message-box-right", "current-message-box-left"];
                                                const messages = document.getElementById("voice-text-panel");
                                                if (messages && messages.children) {
                                                    for (let i = 0; i < messages.children.length; i++) {
                                                        if (messages.children[i].firstElementChild) {
                                                            messages.children[i].firstElementChild.classList.remove(...ELEMENT_CLASS_NAMES);
                                                        }
                                                    }
                                                }

                                                // 現在の音声位置を設定する変数
                                                let currentMessageIndex = 0;
                                                let currentMessageData = null;

                                                // 現在再生時間に該当するメッセージを検索
                                                for (let i = 0; i < state.selected.text_data_json.length; i++) {
                                                    let currentTime = Math.round(player.currentTime);
                                                    let startTime = Math.round(state.selected.text_data_json[i].startTime);
                                                    let endTime = state.selected.text_data_json[i+1] ? 
                                                        Math.round(state.selected.text_data_json[i+1].startTime) : 
                                                        Math.round(state.selected.text_data_json[i].endTime);

                                                    if(currentTime >= startTime && currentTime <= endTime){
                                                        currentMessageIndex = i;
                                                        currentMessageData = state.selected.text_data_json[i];

                                                        // 音声再生中かつ自動スクロールOFFからONに切り替わる場合のみスクロール実行
                                                        if (player.readyState > 0 && !player.paused && !state.auto_scroll_flag) {
                                                            // 該当するメッセージボックスの位置にスクロール
                                                            let element = document.getElementById("message-box-"+i);
                                                            let element2 = document.getElementById("message-box-"+(i+1));
                                                            if (element) {
                                                                let rect = element.getBoundingClientRect();
                                                                let rect2 = element2 ? element2.getBoundingClientRect() : element.getBoundingClientRect();
                                                                panel.scrollTo(0, (rect.bottom + rect2.bottom)/2 + panel.scrollTop - 440);
                                                            }
                                                        }
                                                        break;
                                                    }
                                                }

                                                propSetState({
                                                    auto_scroll_flag: !state.auto_scroll_flag,
                                                    message_box_data: currentMessageData || [],
                                                    message_box_index: currentMessageIndex,
                                                });
                                            }}
                                            DisplayIcon="resize-vertical"
                                            speechBubble={langText.Body.AutoScroll}
                                        />
                                        <ButtonSpeechBubble
                                            className="control-button"
                                            bsSize="xsmall"
                                            onClick={e => copyData("voice-all", state.selected.text_data_json)}
                                            disabled = {state.voice_edit_flag.some(row=> row)}
                                            DisplayIcon="copy"
                                            speechBubble={langText.Body.Copy}
                                        />
                                    </span>
                                    </>
                                    }
                                </Panel.Title>
                            </Panel.Heading>
                            <ViewVoiceTextElement
                                state={state}
                                langText={langText}
                                userInfo={userInfo}
                                copyData={copyData}
                                propSetState={propSetState}
                                updateVoiceData={updateVoiceData}
                                screenName={screenName}
                                getFilterData={getFilterData}
                                getKeywordData={getKeywordData}
                                currentPermission={currentPermission}
                            />
                            <Panel.Footer className="analysis-audio-control-footer">
                                <ViewAudioControlElement
                                    state={state}
                                    langText={langText}
                                    userInfo={userInfo}
                                    copyData={copyData}
                                    propSetState={propSetState}
                                    updateVoiceData={updateVoiceData}
                                    screenName={screenName}
                                    getFilterData={getFilterData}
                                    onPlayHandle={onPlayHandle}
                                    getKeywordData={getKeywordData}
                                    currentPermission={currentPermission}
                                    playbackSettings={this.props.playbackSettings}
                                />
                            </Panel.Footer>
                        </Panel>
                        <Panel bsStyle="info">
                            <Panel.Heading>
                                <Panel.Title>
                                    {langText.Body.Comment}
                                    {state && state.selected && state.selected.comment_data_json &&
                                        //コメントがあれば全体コメントコピーボタン表示\
                                        <span className="pannel-btn-right">
                                            <ButtonSpeechBubble
                                                className="control-button"
                                                bsSize="xsmall"
                                                onClick={e => copyData("comment-all", state.selected.comment_data_json)}
                                                disabled = {state.comment_edit_flag.some(row=> row)}
                                                DisplayIcon="copy"
                                                speechBubble={langText.Body.Copy}
                                            />
                                        </span>
                                    }
                                </Panel.Title>
                            </Panel.Heading>
                            <ViewCommentElement
                                state={state}
                                langText={langText}
                                userInfo={userInfo}
                                copyData={copyData}
                                propSetState={propSetState}
                                insertCommentData={insertCommentData}
                                updateCommentData={updateCommentData}
                                deleteCommentData={deleteCommentData}
                                currentPermission={currentPermission}
                            />
                        </Panel>
                    </>
                );
                break;
        
            case "voiceQualityAnalysisDownload":
                // 分析履歴ダウンロード
                info = (
                    <Panel bsStyle="info">
                        <Panel.Body>
                            <div className="message">
                                <p>{langText.Message.VoiceQualityAnalysisDownloadMessage[0]}</p>
                                <p>{langText.Message.VoiceQualityAnalysisDownloadMessage[1]}</p>
                                <p>{langText.Message.VoiceQualityAnalysisDownloadMessage[2]}</p>
                                <p className="text-danger">{langText.Message.DownloadDeadline}</p>
                            </div>
                            <Col sm={12} md={12} className="padding-left-0">
                                <Col sm={12} md={3} lg={2} className="padding-left-0 margin-top-05 width-auto">
                                    {langText.Body.FileName}
                                </Col>
                                <Col sm={12} md={9} lg={9} className="padding-left-0">
                                    <InlineForm
                                        key="fileName"
                                        controlId="fileName"
                                        type="text"
                                        value={state.fileName}
                                        onChange={e => onTextChange_Limit(e, "fileName", charaLimit.File_Name)}
                                        placeholder={`${userInfo.cm15_id}_${langText.Body.VoiceQualityAnalysis}_${langText.Body.CreateDatetime}`}
                                    />
                                    {hasInvalidFileNameCharacters(state.fileName) &&
                                        <div className="text-danger margin-top--05">
                                            {this.props.langText.Message.InvalidFileNameCharacters}
                                        </div>
                                    }
                                    {typeof state.count === "number" && state.count > this.props.voiceQualityAnalysisCountLimit &&
                                        <div className="text-danger margin-top--05">
                                            {this.props.sprintf(langText.Message.CountLimitExceeded, this.props.voiceQualityAnalysisCountLimit.toLocaleString())}
                                        </div>
                                    }
                                </Col>
                            </Col>
                        </Panel.Body>
                    </Panel>
                );
                break;
            case "callContentDownload":
                // 通話内容ダウンロード
                info = (
                    <Panel bsStyle="info">
                        <Panel.Body>
                            <div className="message">
                                <p>{langText.Message.CallContentDownloadMessage[0]}</p>
                                <p>{langText.Message.CallContentDownloadMessage[1]}</p>
                                <p>{langText.Message.CallContentDownloadMessage[2]}</p>
                                <p className="text-danger">{langText.Message.DownloadDeadline}</p>
                            </div>
                            <Col sm={12} md={12} className="padding-left-0">
                                <Col sm={12} md={3} lg={2} className="padding-left-0 margin-top-05 width-auto">
                                    {langText.Body.FileName}
                                </Col>
                                <Col sm={12} md={9} lg={9} className="padding-left-0">
                                    <InlineForm
                                        key="fileName"
                                        controlId="fileName"
                                        type="text"
                                        value={state.fileName}
                                        onChange={e => onTextChange_Limit(e, "fileName", charaLimit.File_Name)}
                                        placeholder={`${userInfo.user_name_sei + userInfo.user_name_mei} + ${langText.Body.CreateDatetime}`}
                                    />
                                    {hasInvalidFileNameCharacters(state.fileName) &&
                                        <div className="text-danger margin-top--05">
                                            {this.props.langText.Message.InvalidFileNameCharacters}
                                        </div>
                                    }
                                    {typeof state.count === "number" && state.count > this.props.callContentCountLimit &&
                                        <div className="text-danger margin-top--05">
                                            {this.props.sprintf(langText.Message.CountLimitExceeded, this.props.callContentCountLimit.toLocaleString())}
                                        </div>
                                    }
                                </Col>
                            </Col>
                        </Panel.Body>
                    </Panel>
                );
                break;

            case "callMeasurementDownload":
                // 発話計測ダウンロード
                info = (
                    <Panel bsStyle="info">
                        <Panel.Body>
                            <div className="message">
                                <p>{langText.Message.CallMeasurementDownloadMessage[0]}</p>
                                <p>{langText.Message.CallMeasurementDownloadMessage[1]}</p>
                                <p>{langText.Message.CallMeasurementDownloadMessage[2]}</p>
                                <p className="text-danger">{langText.Message.DownloadDeadline}</p>
                            </div>
                            <Col sm={12} md={12} className="padding-left-0">
                                <Col sm={12} md={3} lg={2} className="padding-left-0 margin-top-05 width-auto">
                                    {langText.Body.FileName}
                                </Col>
                                <Col sm={12} md={9} lg={9} className="padding-left-0">
                                    <InlineForm
                                        key="fileName"
                                        controlId="fileName"
                                        type="text"
                                        value={state.fileName}
                                        onChange={e => onTextChange_Limit(e, "fileName", charaLimit.File_Name)}
                                        placeholder={`${userInfo.user_name_sei + userInfo.user_name_mei} + ${langText.Body.CreateDatetime}`}
                                    />
                                    {hasInvalidFileNameCharacters(state.fileName) &&
                                        <div className="text-danger margin-bottom-05 margin-top--05">
                                            {this.props.langText.Message.InvalidFileNameCharacters}
                                        </div>
                                    }
                                    {typeof state.count === "number" && state.count > this.props.callMeasurementCountLimit &&
                                        <div className="text-danger margin-top--05 margin-bottom-05">
                                            {this.props.sprintf(langText.Message.CountLimitExceeded, this.props.callMeasurementCountLimit.toLocaleString())}
                                        </div>
                                    }
                                </Col>
                            </Col>
                            <Col sm={12} md={12} className="padding-left-0">
                                <Col sm={12} md={6} lg={6} className="padding-left-0">
                                    <InlineForm
                                        key="operatorKeyword"
                                        controlId="operatorKeyword"
                                        label={langText.Body.OperatorKeyword}
                                        type="select"
                                        onChange={e => onSelectChange(e, "operatorKeyword")}
                                        options={state.keywordGroupSelect}
                                        value={state.operatorKeyword}
                                        isClearable={true}
                                        validationState={validationHandle("operatorKeyword")}
                                        placeholder={langText.SelectOption.Placeholder}
                                    />    
                                </Col>
                                <Col sm={12} md={6} lg={6} className="padding-left-0">
                                    <InlineForm
                                        key="customerKeyword"
                                        controlId="customerKeyword"
                                        label={langText.Body.CustomerKeyword}
                                        type="select"
                                        onChange={e => onSelectChange(e, "customerKeyword")}
                                        options={state.keywordGroupSelect}
                                        value={state.customerKeyword}
                                        isClearable={true}
                                        validationState={validationHandle("customerKeyword")}
                                        placeholder={langText.SelectOption.Placeholder}
                                    />
                                </Col>
                            </Col>
                            <Col sm={12} md={12} className="padding-left-0">
                                <p>
                                    <a href="/KeywordGroup">{langText.Message.CallMeasurementDownloadKeywordMessage[0]}</a>
                                    {langText.Message.CallMeasurementDownloadKeywordMessage[1]}
                                </p>
                            </Col>
                            {
                                (state.operatorKeyword || state.customerKeyword) &&
                                <Col sm={12} md={12} className="padding-left-0">
                                    <Col sm={12} md={6} lg={6} className="padding-left-0">
                                        <InlineForm.static
                                            key="operatorKeywordList"
                                            controlId="operatorKeywordList"
                                            label={langText.Body.OperatorKeywordList}
                                        >
                                            {state.operatorKeyword && state.operatorKeyword.keywords.map(row => {
                                                return (<p>{row}</p>);
                                            })}
                                        </InlineForm.static>    
                                    </Col>
                                    <Col sm={12} md={6} lg={6} className="padding-left-0">
                                        <InlineForm.static
                                            key="customerKeywordList"
                                            controlId="customerKeywordList"
                                            label={langText.Body.CustomerKeywordList}
                                        >
                                            {state.customerKeyword && state.customerKeyword.keywords.map(row => {
                                                return (<p>{row}</p>);
                                            })}
                                        </InlineForm.static>
                                    </Col>
                                </Col>
                            }
                        </Panel.Body>
                    </Panel>
                );
                break;
                
            default:
                break;
        }

        return info;
    }
    render() {
        let modalType = this.props.state.modalType;
        
        return (
            <>
                {this.getModalInfo(modalType)}
            </>
        );
    }
}
